import SheetComponent from "./index";

import {Trans} from "@lingui/react/macro"
import {t} from "@lingui/core/macro"
import {currencyFormat} from "../../components/permissions/functions";
import {DynamicIcon} from "lucide-react/dynamic";
import moment from "moment";
import {MobCard} from "../components/MobCard";
import ApiService from "../../services/ApiService";
import {
    translateMethod,
    translateMethodIcon,
    translatePlatform,
    translateSource, translateSourceIcon
} from "../../views/app-views/paiements/functions";
import ReactCountryFlag from "react-country-flag";
import React, {Fragment} from "react";
import { API_BASE_URL, ASSET_BASE_URL, isMobileApp, MOBCOLORS, MOBILE_PREFIX_PATH } from '../../configs/AppConfig';
import {Descriptions, Image, notification, Popconfirm} from "antd";
import IntlMessage from "../../components/util-components/IntlMessage";
import {removeFieldType} from "../../views/editors/WebEditor/formPlugins";
import ModalLink from "../../modals/ModalLink";
import ModalUser from "../../modals/ModalUser";
import ModalContact from "../../modals/ModalContact";
import ModalCerfa from "../../modals/ModalCerfa";
import ModalEditCerfa from "../../modals/ModalEditCerfa";
import ModalCerfaGroupe from "../../modals/ModalCerfaGroupe";
import ModalChangeContact from "../../views/app-views/paiements/ModalChangeContact";
import ModalChangeOrigin from "../../views/app-views/paiements/ModalChangeOrigin";
import ModalDeletePaiement from "../../views/app-views/paiements/ModalDeletePaiement";
import ModalMessages from "../../views/app-views/messages/ModalEdit";
import {useActionSheet, withActionSheet} from "../providers/ActionSheetProvider";
import AppService from "../../services/AppService";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import MobPressable from "../components/MobPressable";
import {useNavigate} from "react-router-shim";
import ModalChangeDettes from '../../views/app-views/paiements/ModalChangeDettes';

class SheetPaiementDetail extends SheetComponent
{
    constructor(props) {
        super(props);
    }

    onClose(){

    }

    componentDidMount(){
        this.getAssocs()
    }

    getData(){
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()
        const item= payload?.params?.item
        const parentRefresh= payload?.params?.parentRefresh

        if(item)
        {
            ApiService.post("/paiements",{searchId:item.id,filters:{},sorter:{}}).then(res=>{
                if(Array.isArray(res.data) && res.data.length>0){
                    let _item=res.data[0]
                    sheetContext.setPayloadParams({item:_item})
                }
            })
        }

        if(typeof parentRefresh === "function"){
            parentRefresh()
        }
    }

    async getAssocs() {
        var res = await ApiService.get("/auth/assoc")
        if (res.success) {
            this.setState({assocs: res.data})
        }
    }

    async resendCerfa(id) {
        var res = await ApiService.get("/paiements/cerfa/resend/" + id)
        console.log(res)

        if (res.success) {
            notification.success({
                message: (<IntlMessage id="success.send"/>)
            })
        } else {
            notification.error({
                message: (<IntlMessage id="error.send"/>)
            })
        }
    }

    async addCerfa(id) {
        var res = await ApiService.get("/paiements/addCerfa/" + id)
        console.log(res)

        if (res.success) {
            notification.success({
                message: (<IntlMessage id="success.edit"/>)
            })

            //await this.getData()
        } else {
            notification.error({
                message: (<IntlMessage id="error.edit"/>)
            })
        }
    }


    renderContent()
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()

        const item= payload?.params?.item
        if(!item){
            return null
        }
        const row=item

        console.log(item)

        var assoc = null
        if (this.state.assocs.length > 0) {
            assoc = this.state.assocs.find(i => i.value === item.assoc)
        }

        let showExtraCard=false
        const extras=[]
        if(item?.info?.extra)
        {
            showExtraCard=true
            for(let k of Object.keys(item?.info.extra))
            {
                if(k==="ddn"){
                    extras.push({key:t`Date de Naissance`,value:moment(new Date(item?.info.extra[k])).format("DD/MM/YYYY")})
                    continue
                }
                extras.push({key:removeFieldType(k),value:item?.info.extra[k]})
            }
        }
        if(item.commentaire?.length>0 || (item?.extra && Object.keys(item?.extra).length>0) ){
            showExtraCard=true
        }

        let raisonRoute=null
        switch(item.type){
            case "CAISSE":
                raisonRoute=MOBILE_PREFIX_PATH+"/cagnottes/fiche?id="+item.typeId
                break
        }


        var MENU = []

        if (row.info) {
            MENU.push({
                icon:"user-pen",
                text:(
                    <Trans>Changer le Contact</Trans>
                ),
                onClick:()=>{
                    this.modalChangeContact.show(row.id, row.contact.id)
                }
            },)

            MENU.push({
                icon:"square-pen",
                text:(
                    <Trans>Changer la raison du Paiement</Trans>
                ),
                onClick:()=>{
                    this.modalChangeOrigin.show(row.id, row.contact.id, row.type, row.typeId)
                }
            },)
        }

        if (!row.cerfa && !row.cerfaYear) {
            MENU.push({
                icon:"file-plus",
                warning:true,
                text: (<Trans>Ajouter un Cerfa</Trans>),
                onClick:()=>{
                    this.props.actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir ajouter un Cerfa à ce Paiement ?</Trans>),()=>{
                        this.addCerfa(row.id)
                    })
                }
            },)
        }

        if (item.cerfaId) {
            MENU.push({
                icon:"file-pen",
                warning:true,
                text: (<Trans>Modifier le Reçu Cerfa</Trans>),
                onClick:()=>{
                    this.modalEditCerfa.show(row)
                }
            },)
        }

        if(row.contact?.id && row.type!=="DETTE" && ["GENERAL","CAISSE","LIVRET"].includes(row.type))
        {
            MENU.push({
                icon:"file-pen",
                warning:true,
                text: (<Trans>Attribuer des promesses de dons</Trans>),
                onClick:()=>{
                    this.modalChangeDettes.show(row)
                }
            },)
        }

        if (row.source === "ADMIN") {
            MENU.push({
                icon:"trash-2",
                danger:true,
                text:(
                    <Trans>Supprimer le Paiement</Trans>
                ),
                onClick:()=>{
                    this.modalDeletePaiement.show(row.id)
                }
            },)
        }


        if (row.source === "BORNE" && row.finalized === false) {
            MENU.push({
                icon:"link",
                text:(
                    <Trans>Récuperer le lien du Reçu</Trans>
                ),
                onClick:()=>{
                    this.modalLink.setObject(row).getLink("UPDATE-PAIEMENT", {id: row.id})
                }
            },)
        }

        let DropdownComponent=null
        if(!isMobileApp){
            DropdownComponent= this.props.actionSheetManager.toDropdown(MENU)
            //console.log("DropdownComponent", DropdownComponent)
        }

        return(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>

                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",textAlign:"center",gap:0}}>
                    <span style={{fontSize:15}}>{moment(item.datetime).format("DD/MM/YYYY à HH:mm")}</span>
                    <span style={{fontSize:18,fontWeight:"bold",color:MOBCOLORS.blue.color}}>{item.name}</span>
                </div>


                <div style={{display:"flex",flexDirection:"column",gap:20}}>
                    <MobCard style={{display:"flex",flexDirection:"column",gap:10,position:"relative"}}>

                        <div style={{position:"absolute",right:0,paddingRight:10,paddingTop:5}}>
                            {isMobileApp ?(
                                <MobEditButtonIcon icon={"ellipsis-vertical"} onClick={()=>{
                                    if(MENU.length>0) {
                                        this.props.actionSheetManager.open(MENU)
                                    }
                                }}/>
                            ):(
                                <DropdownComponent>
                                    <a onclick={(e)=>e.preventDefault()}>
                                        <MobEditButtonIcon icon={"ellipsis-vertical"}/>
                                    </a>
                                </DropdownComponent>
                            )}

                        </div>


                        <span style={{
                            alignSelf: "center",
                            color: MOBCOLORS.green.color,
                            fontWeight: "bold",
                            fontSize: 26
                        }}>+ {currencyFormat(item.amount / 100, item.devise)}</span>

                        <div style={{
                            display: "flex",
                            width: "100%",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0 5%"
                        }}>
                            <span style={{alignSelf:"center",color:MOBCOLORS.red.color,fontSize:15,fontStyle:"italic",fontWeight:"300"}}><Trans>Frais bancaire</Trans> : <span style={{fontWeight:"bold",fontStyle:"normal"}}>{currencyFormat(((item.bankFees || 0) + (item.orgfees || 0))/100,item.devise)}</span></span>

                            <span style={{alignSelf:"center",color:MOBCOLORS.orange.color,fontSize:15,fontStyle:"italic",fontWeight:"300"}}><Trans>Total Net</Trans> : <span style={{fontWeight:"bold",fontStyle:"normal"}}>{currencyFormat(item.finalAmount / 100,item.devise)}</span></span>
                        </div>

                        <Divider/>

                        {assoc &&(
                            <Item name={(<Trans>Association</Trans>)} value={assoc.label}/>
                        )}

                        {item.contact &&(
                            <Item name={(<Trans>Contact</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    //this.props.sheetContext.cancel()
                                    //this.props.navigate(MOBILE_PREFIX_PATH+"/contacts/fiche?id="+item.contact.id)
                                    this.props.sheetContext.openContact(item.contact)
                                }}>
                                    <DynamicIcon name={"contact"} color={MOBCOLORS.blue.color} size={18}/>
                                    {item.contact?.nom} {item.contact?.prenom}
                                </span>
                            </Item>
                        )}

                        {item.raisons?.[0]?.label &&(
                            <Item name={(<Trans>Raison Paiement</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:raisonRoute?"underline":"none",cursor:raisonRoute?"pointer":"normal"}} onClick={()=>{
                                    if(raisonRoute) {
                                        this.props.sheetContext.cancel()
                                        this.props.navigate(raisonRoute)
                                    }
                                }}>
                                    {item.raisons?.[0]?.label}
                                </span>
                            </Item>
                        )}

                        {item.abo &&(
                            <Item name={(<Trans>Abonnement</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    ApiService.post("/abonnements",{searchId:item.abo,filters:{},sorter:{}}).then(res=>{
                                        if(Array.isArray(res.data) && res.data.length>0){
                                            let _item=res.data[0]
                                            this.props.sheetContext.open("SheetAbonementDetail",_item.payload.name,{item:_item})
                                        }
                                    })
                                }}>
                                    <Trans>Voir l'abonnement</Trans>
                                </span>
                            </Item>
                        )}

                        <Item name={(<Trans>Méthode paiement</Trans>)}>
                            <div style={{display: "flex", gap: 5}}>
                                <span>{translateMethod(item.method)}</span>
                                <div style={{
                                    backgroundColor: MOBCOLORS.cyan.color,
                                    padding: 5,
                                    borderRadius: 10
                                }}>
                                    <DynamicIcon name={translateMethodIcon(item.method)}
                                                 color={"#FFF"} size={15} style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}/>
                                </div>
                            </div>
                        </Item>

                        <Item name={(<Trans>Source paiement</Trans>)}>
                            <div style={{display: "flex", gap: 5}}>
                                <span>{translateSource(item.source)}</span>
                                <div style={{
                                    backgroundColor: MOBCOLORS.purple.color,
                                    padding: 5,
                                    borderRadius: 10
                                }}>
                                    <DynamicIcon name={translateSourceIcon(item.source)}
                                                 color={"#FFF"} size={15} style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}/>
                                </div>
                            </div>
                        </Item>

                        {item.platform && (
                            <Item name={(<Trans>Plateforme paiement</Trans>)} value={translatePlatform(item.platform)}/>
                        )}

                        {item.card && (
                            <Item name={(<Trans>Carte</Trans>)}>
                            <span style={{display: "flex", gap: 10, alignItems: "center", height: "100%"}}>
                               {String(item.card?.brand).charAt(0).toUpperCase() + String(item.card?.brand).slice(1)?.toLowerCase()}
                                <DividerVertical/>
                                *****{item.card.last}
                                <DividerVertical/>
                                 <ReactCountryFlag
                                     countryCode={item.card.country}
                                 />
                            </span>
                            </Item>
                        )}

                    </MobCard>


                    {(item.raisons.filter(i=>i.type==="DETTE").length>0) &&(
                        <MobCard>
                            <Section title={<Trans>Promesses de dons</Trans>}>

                                {item.raisons.filter(i=>i.type==="DETTE").map((raison, index) => {

                                    return (
                                        <div style={{display:"flex",flexDirection:"column",gap:10,padding:"0 2.5%"}}>
                                            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",fontSize:15}} onClick={()=>{
                                                ApiService.post("/promesses",{searchId:raison.value,filters:{},sorter:{}}).then(res=>{
                                                    if(Array.isArray(res.data) && res.data.length>0){
                                                        let _item=res.data[0]
                                                        this.props.sheetContext.open("SheetPromesseDetail",_item.name,{item:_item})
                                                    }
                                                })
                                            }}>

                                                <div style={{display:"flex",textDecorationLine:"underline",cursor:"pointer",textAlign:"center",alignItems:"center",width:"80%",overflow:"hidden",textOverflow:'ellipsis',color:MOBCOLORS.blue.color}}>
                                                    <span>{raison.label}</span>
                                                </div>

                                                <DynamicIcon name={"chevron-right"} color={"#000"} size={18}
                                                             style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
                                            </div>

                                            <Divider/>
                                        </div>
                                    )
                                })}

                            </Section>
                        </MobCard>
                    )}


                    {item?.facturation?.adresse &&(
                        <div>

                            {(item.cerfaId || item.recuId) && (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: 15,
                                    marginTop: 10
                                }}>

                                    <SheetButton icon={"eye"} name={(<Trans>Consulter</Trans>)} onClick={()=>{
                                        if(item.cerfaId) {
                                            window.open(API_BASE_URL + "/cerfas/" + item.cerfaId,"_blank")
                                        }else {
                                            window.open(API_BASE_URL + "/recus/" + item.recuId,"_blank")
                                        }
                                    }}/>

                                    {item.cerfaId &&(
                                        <SheetButton icon={"send"} name={(<Trans>Renvoyer</Trans>)} onClick={() => {
                                            this.resendCerfa(item.cerfaId)
                                        }}/>
                                    )}

                                    <SheetButton icon={"share"} name={(<Trans>Partager</Trans>)} onClick={() => {
                                        let url=null
                                        let filename=null
                                        if(item.cerfaId) {
                                            url=API_BASE_URL+"/cerfas/" + item.cerfaId
                                            filename=item.cerfaId+".pdf"
                                        }else {
                                            url=API_BASE_URL+"/recus/" + item.recuId
                                            filename=item.recuId+".pdf"
                                        }


                                        if(!AppService.isAvailable && navigator?.share){
                                            navigator.share({
                                                title:filename,
                                                url:url,
                                            })
                                        }else {
                                            AppService.shareBase64(url,{
                                                type: "application/pdf",
                                                filename:filename
                                            })
                                        }
                                    }}/>
                                </div>
                            )}


                            <MobCard>
                                <Section title={item?.cerfaId?(<Trans>Informations du Cerfa</Trans>):(<Trans>Informations du Reçu</Trans>)}>

                                    <Item name={(<Trans>Nom Complet</Trans>)}
                                          value={item?.info?.prenom + " " + item?.info?.nom}/>
                                    <Item name={(<Trans>Email</Trans>)} value={item?.info?.email}/>
                                    <Item name={(<Trans>Téléphone</Trans>)} value={item?.info?.tel}/>
                                    {item?.facturation?.perso === false && (
                                        <Fragment>
                                            <Item name={(<Trans>Entreprise</Trans>)} value={item?.facturation?.raison}/>
                                            <Item name={(<Trans>Identifiant d'entreprise</Trans>)} value={item?.facturation?.siren}/>
                                        </Fragment>
                                    )}
                                    <Item name={(<Trans>Adresse</Trans>)} value={item?.facturation?.adresse+" "+item?.facturation?.postal+" "+item?.facturation?.ville+" "+item?.facturation?.pays}/>

                                </Section>
                            </MobCard>
                        </div>
                    )}

                    {showExtraCard &&(
                        <MobCard>

                            {item?.extra?.chequeId && (
                                <Item label={t`Numéro du Chèque`} value={item?.extra.chequeId}/>
                            )}

                            {item?.extra?.chequeImage && (
                                <Item label={t`Image du Chèque`} value={item?.extra.chequeImage}>
                                    <SheetButton name={t`Voir l'image`} onClick={()=>{}}/>
                                </Item>
                            )}

                            {extras.map(i=>{
                                return(
                                    <Item name={i.key} value={i.value}/>
                                )
                            })}

                            {item?.commentaire &&(
                                <Item name={(<Trans>Commentaire</Trans>)} value={item?.commentaire}/>
                            )}
                        </MobCard>
                    )}

                </div>


                <ModalLink getRef={(ref) => this.modalLink = ref} onFinish={() => {
                }}/>
                <ModalUser getRef={(ref) => this.modalUser = ref} onFinish={() => {
                }}/>
                <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                }}/>
                <ModalCerfa getRef={(ref) => this.modalCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalEditCerfa getRef={(ref) => this.modalEditCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalCerfaGroupe getRef={(ref) => this.modalCerfaGroupe = ref} onFinish={() => this.getData(true)}/>
                <ModalChangeContact getRef={(ref) => this.modalChangeContact = ref} onFinish={() => this.getData()}/>
                <ModalChangeOrigin getRef={(ref) => this.modalChangeOrigin = ref} onFinish={() => this.getData()}/>
                <ModalChangeDettes getRef={(ref) => this.modalChangeDettes = ref} onFinish={() => this.getData()}/>
                <ModalDeletePaiement getRef={(ref) => this.modalDeletePaiement = ref} onFinish={() => this.getData()}/>
                <ModalMessages getRef={(ref) => this.modalMessages = ref} onFinish={() => {
                }}/>
            </div>
        )
    }
}

function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigate(withActionSheet(SheetPaiementDetail))

function Divider(){
    return(
        <div style={{width:"100%",paddingLeft:"5%",opacity:0.05}}>
            <div style={{width:"100%",borderTop:"1px solid #4A5568"}}/>
        </div>
    )
}

function DividerVertical(){
    return(
        <div style={{height:20,opacity:0.05}}>
            <div style={{height:"100%",borderLeft:"1px solid #4A5568"}}/>
        </div>
    )
}

function Section({title,children})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>

            <div style={{display:"flex",flexDirection:"row",textAlign:"center",justifyContent:"center",alignItems:"center"}}>
                <span style={{color:"#333",fontSize:18,fontWeight:"300"}}>{title}</span>
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:10}}>
                {children}
            </div>
        </div>
    )
}

function Item({name,value,color,children,bold})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10,padding:"0 2.5%"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",fontSize:15}}>

                <span style={{width:"40%",fontStyle:"italic",fontWeight:"300",color:"#333",fontSize:13}}>{name}</span>

                <div style={{display:"flex",textAlign:"right",alignItems:"flex-end",maxWidth:"60vw",overflow:"hidden",textOverflow:'ellipsis',color:color || MOBCOLORS.blue.color}}>
                    {value ?(
                        <span>{value.replaceAll("undefined","").trim() || t`[Inconnu]`}</span>
                    ):(
                        <div>{children}</div>
                    )}
                </div>
            </div>

            <Divider/>
        </div>
    )
}

function SheetButton({name,icon,onClick})
{
    return(

        <MobPressable style={{cursor:"pointer",display:"flex",alignItems:"center",gap:5,backgroundColor:MOBCOLORS.blue.backgroundColor,padding:"5px 15px",borderRadius:16}} onClick={onClick}>
            <span style={{fontWeight:"400",color:MOBCOLORS.blue.color}}>{name}</span>
            <DynamicIcon name={icon} color={MOBCOLORS.blue.color} size={18} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
        </MobPressable>
    )
}
